import moment from "moment";
import { MaintenanceRequest } from "@/models/MaintenanceRequest";
import { MaintenanceRequestCadences } from "@/enums/MaintenanceRequestCadences";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { EventLocationsMixin } from "@/mixins/EventLocations";
import { MaintenancePriority } from "@/enums/MaintenancePriority";
import * as firebase from "firebase";

export default {
  name: "scheduledMaintenanceDlg",
  mixins: [
    EventLocationsMixin
  ],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      newMaintenanceRequest: new MaintenanceRequest(),
      newVendor: null,
      minDate: moment(new Date()).format("YYYY-MM-DD"),
      isCreate: false,
      isUpdate: false,
      loading: false,
      reqType: null
    }
  },
  computed: {
    scheduledMaintenanceRequests() {
      return this.$store.state.maintenanceModule.scheduledMaintenance;
    },
    maintenanceTypes() {
      return this.$store.state.maintenanceModule.maintenanceTypes;
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    maintenanceCategories() {
      return this.$store.getters.maintenanceCategories;
    },
    maintenanceRequestCadences() {
      return Object.values(MaintenanceRequestCadences);
    },
    MaintenanceTechnicians() {
      return [...this.$store.state.userModule.maintenanceUsers, ...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })];
    },
    maintenancePriority() {
      return Object.values(MaintenancePriority);
    },
    user() {
      return this.$store.state.authModule.user;
    }
  },
  watch: {
    reqType(requestType) {
      this.newMaintenanceRequest.title = requestType.name;
      this.newMaintenanceRequest.categoryId = requestType.categoryId;
      this.newMaintenanceRequest.department = requestType.department;
      this.newMaintenanceRequest.typeId = requestType.id;
      this.newMaintenanceRequest.icon = requestType.icon;
    },
    newVendor(vendor) {
      if(vendor != null){
        this.newMaintenanceRequest.assignee = vendor.name;
        this.newMaintenanceRequest.assigneeId = vendor.id;
        this.newMaintenanceRequest.assigneeEmail = vendor.email;
        this.newMaintenanceRequest.assigneeDate = firebase.firestore.Timestamp.now();
      }
    },
    'newMaintenanceRequest.locationId'(locationId) {
      if(locationId != null) {
        this.newMaintenanceRequest.location = this.eventLocations?.find(x => x.id === locationId)?.name;
      }
    },
    'newMaintenanceRequest.categoryId'(categoryId) {
      if(categoryId != null) {
        this.newMaintenanceRequest.category = this.maintenanceCategories?.find(x => x.id === categoryId)?.name;
      }
    },
  },
  methods: {
    open(status: string, data?: MaintenanceRequest) {
      this.dialog = true;

      if(status === "create") {
        this.isCreate = true;
      }

      if(status === "update") {
        this.isUpdate = true;
        this.newMaintenanceRequest = data;
        this.newVendor = this.MaintenanceTechnicians?.filter(x => (x?.id === data?.vendorId) || (x?.id === data?.assigneeId))[0] ?? null;
      }
    },
    async submit() {
      this.loading = true;

      if(this.isCreate) {
        await this.createMaintenanceSchedule();
      }
      if(this.isUpdate) {
        await this.updateMaintenanceSchedule();
      }
    },
    async createMaintenanceSchedule() {
      this.newMaintenanceRequest.active = true;
      this.newMaintenanceRequest.facilityId = this.facility.id;
      this.newMaintenanceRequest.createdByStaffId = this.user.id;
      this.newMaintenanceRequest.createdByStaffName = this.user.name;

      if(this.newMaintenanceRequest.cadence) {
        this.newMaintenanceRequest.nextMaintenance = this.addCadenceInterval(this.newMaintenanceRequest);
      }

      await this.$store
        .dispatch('createScheduledMaintenance', Object.assign({}, this.newMaintenanceRequest))
        .then(() => {
          this.$toast.open({
            message: this.$t("MaintenanceManagement.MaintenanceScheduledSuccessfullyCreated"),
            type: "success"
          });

         this.close();
        }).catch((err) => {
          console.log(err.message)
          this.$toast.open({
            message: this.$t("GeneralTranslations.UnhandledError"),
            type: "error"
          });
          this.loading = false;
        });
    },
    addCadenceInterval(request: any) {
      let nextMaintenance = request.startDate;

      switch (request.cadence) {
        case 'yearly':
          nextMaintenance = moment(nextMaintenance).add(1, 'year');
          break;
        case 'monthly':
          nextMaintenance = moment(nextMaintenance).add(1, 'month');
          break;
        case 'weekly':
          nextMaintenance = moment(nextMaintenance).add(1, 'week');
          break;
        case 'daily':
          nextMaintenance = moment(nextMaintenance).add(1, 'day');
          break;
      }

      return moment(nextMaintenance).format("YYYY-MM-DD");
    },
    async updateMaintenanceSchedule() {
      if(this.newMaintenanceRequest?.id?.length) {
        await this.$store.dispatch("updateScheduledMaintenance", this.newMaintenanceRequest)
          .then(() => {
            this.$toast.open({
              type: "success",
              message: this.$t("MaintenanceSchedule.MaintenanceScheduleUpdateSuccess")
            })
            this.close();
          }).catch((err) => {
            console.log(err.message)
            this.$toast.open({
              type: "error",
              message: this.$t("GeneralTranslations.UnhandledError")
            })
            this.loading = false;
          })
      }
    },
    close() {
      this.loading = false;
      this.newMaintenanceRequest = {}
      this.newVendor = null;
      this.isCreate = false;
      this.isUpdate = false
      this.dialog = false;
      this.reqType = null;
    },
    clearVendor() {
      this.newVendor = null;
      delete this.newMaintenanceRequest.assignee;
      delete this.newMaintenanceRequest.assigneeId;
      delete this.newMaintenanceRequest.assigneeEmail;
      delete this.newMaintenanceRequest.assigneeDate;
      delete this.newMaintenanceRequest.priority;
    }
  }
}